import React from 'react';

const PatientEditProfileNextScreen = () => {
  return <></>;
};

export default PatientEditProfileNextScreen;
